<div class="space-y-4 list-container">
  <h1 class="text-2xl font-bold">Busca de Produtos</h1>

  @if (error()) {
    <app-alert [type]="'danger'">{{ error() }}</app-alert>
  }

  <form (ngSubmit)="search()" class="flex flex-col gap-3 md:flex-row md:items-end md:flex-wrap">
    <div class="w-52">
      <label class="block text-sm font-medium mb-1">Tipo de busca</label>
      <select
        [ngModel]="searchType()"
        (ngModelChange)="searchType.set($event)"
        name="searchType"
        class="w-full control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white"
      >
        <option [ngValue]="'RefId'">RefId (string)</option>
        <option [ngValue]="'ProductName'">Nome do produto (string)</option>
        <option [ngValue]="'ProductId'">ID do produto (number)</option>
        <option [ngValue]="'SkuId'">ID do SKU (number)</option>
      </select>
    </div>

    <div class="flex-1 min-w-[180px]">
      <label class="block text-sm font-medium mb-1">Valor</label>
      <input
        type="text"
        [ngModel]="searchValue()"
        (ngModelChange)="searchValue.set($event)"
        name="searchValue"
        [placeholder]="
          searchType() === 'ProductId'
            ? 'Informe o ProductId'
            : searchType() === 'SkuId'
              ? 'Informe o SkuId'
              : searchType() === 'RefId'
                ? 'Informe o RefId'
                : 'Informe o ProductName'
        "
        class="w-full control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white"
      />
    </div>

    <div class="w-32">
      <label class="block text-sm font-medium mb-1">Ordenação</label>
      <select
        [ngModel]="order()"
        (ngModelChange)="order.set($event)"
        name="order"
        class="w-full control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white"
      >
        <option [ngValue]="'DESC'">DESC</option>
        <option [ngValue]="'ASC'">ASC</option>
      </select>
    </div>

    <div class="w-28">
      <label class="block text-sm font-medium mb-1">Tamanho</label>
      <input
        type="number"
        min="1"
        [ngModel]="size()"
        (ngModelChange)="size.set($event)"
        name="size"
        class="w-full control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white"
      />
    </div>

    <div class="md:ml-2">
      <app-button type="submit" color="primary">Buscar</app-button>
    </div>
  </form>

  @if (loading()) {
    <div class="my-4">
      <app-loading size="large" color="primary" />
    </div>
  }

  @if (!loading()) {
    <div class="overflow-x-auto mt-2">
      <table class="table-auto w-full border-collapse border border-slate-400">
        <thead class="bg-neutral-100 dark:bg-neutral-700">
          <tr class="bg-neutral-100 dark:bg-neutral-700">
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">ID</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Imagem</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Nome</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Skus</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Atualizado</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Criado</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Ativo</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Tipo</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2"></th>
          </tr>
        </thead>
        <tbody>
          @for (p of data(); track p.id; let even = $even) {
            <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ p.id }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                @if (p.mainImageUrl) {
                  <img [ngSrc]="p.mainImageUrl" width="48" height="48" alt="img" class="w-12 h-12 object-cover rounded" />
                }
              </td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                <div class="font-medium">{{ p.name }}</div>
                <div class="text-xs text-neutral-500">
                  <a [href]="`https://site.fastshop.com.br/${p.linkId}/p`" target="_blank" rel="noreferrer noopener">{{
                    p.linkId
                  }}</a>
                </div>
              </td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ p.totalSku }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ p.lastUpdateDate }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ p.creationDate }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ p.isActive ? 'Sim' : 'Não' }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2 text-center">
                @if (p.isMarketplace) {
                  <span class="inline-block px-2 py-0.5 text-xs font-semibold rounded-full bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200">3P</span>
                } @else {
                  <span class="inline-block px-2 py-0.5 text-xs font-semibold rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">1P</span>
                }
              </td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                <div class="flex gap-1">
                  <a [routerLink]="['/catalog/product', p.id]" class="inline-flex items-center justify-center rounded-md bg-blue-600 hover:bg-blue-700 text-white px-2 py-1 text-sm"><i [innerHTML]="'eye' | feather: { width: 14, height: 14 }"></i></a>
                  <app-button color="success" size="small" (buttonClick)="openModal(p)" icon="activity"></app-button>
                </div>
              </td>
            </tr>
          } @empty {
            <tr class="bg-neutral-50 dark:bg-neutral-800">
              <td colspan="9" class="p-3 text-sm text-center">Nenhum resultado.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (paginationState().totalItems > 0 || data().length > 0) {
      <app-pagination
        [paginationState]="paginationState()"
        [onPaginationChange]="onPageChange"
        displayMode="simple"
      />
    }
  }
</div>

<app-modal #inventoryModal [title]="modalTitle()">
  <div class="max-h-[70vh] overflow-auto">
    @if (modalProduct()?.skuOffers && modalProduct()!.skuOffers!.length > 0) {
      <app-tabs [defaultActiveId]="modalProduct()!.skuOffers![0].id.toString()">
        @for (sku of modalProduct()!.skuOffers; track sku.id) {
          <app-tab-pane [id]="sku.id.toString()" [label]="sku.id.toString()">
            <table class="w-full text-sm mt-2">
              <thead class="bg-neutral-50 dark:bg-neutral-800">
                <tr>
                  <th class="text-left p-2">ID</th>
                  <th class="text-left p-2">Seller</th>
                  <th class="text-left p-2">Canais</th>
                  <th class="text-left p-2">Preço</th>
                  <th class="text-left p-2">Estoque</th>
                </tr>
              </thead>
              <tbody>
                @for (row of sku.sellers; track row.id) {
                  <tr class="border-t border-neutral-200 dark:border-neutral-700">
                    <td class="p-2">{{ row.id }}</td>
                    <td class="p-2">{{ row.name }}</td>
                    <td class="p-2">{{ getSalesChannelString(row.saleChannel) }}</td>
                    <td class="p-2 font-semibold">{{ row.price | currency:'BRL':'symbol' }}</td>
                    <td class="p-2">{{ row.inventory }}</td>
                  </tr>
                } @empty {
                  <tr>
                    <td colspan="5" class="p-2 text-center text-sm">Este SKU não tem preço nem inventário.</td>
                  </tr>
                }
              </tbody>
            </table>
          </app-tab-pane>
        }
      </app-tabs>
    } @else {
      <div class="text-sm">Cadastro incompleto. Validar preços ou inventário.</div>
    }
  </div>
</app-modal>
